<template>
  <div>
    <v-container fluid>
      <date-filter v-model="selectedDate" @changeDate="onDateChanged" :default-filter="'today'"></date-filter>
    </v-container>
    <v-container>
      <v-data-table
        expand
        :loading="loading"
        v-bind:pagination.sync="pagination"
        :headers="headers"
        :items="desserts"
        class="elevation-1 scgallrenttable"
      >
        <template v-slot:items="props">
          <tr>
            <!-- <td class="text-xs-center">{{ props.item.productid }}</td> -->
            <td class="text-xs-center">{{ props.item.adminname }}</td>
            <td class="text-xs-center">
              <span
                v-html=" dayLeft(parseInt(props.item.closetask) > 0 ? (props.item.timereply / parseInt(props.item.closetask)).toFixed(0) : 0) "
              ></span>
            </td>
            <td class="text-xs-center">{{ props.item.closetask | numberFormat }}</td>
            <td class="text-xs-center">{{ props.item.latestreply | dateFormat('DD/MM/YYYY HH:mm') }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import { mapGetters } from 'vuex'
import DateFilter from './DateFilter'
export default {
  components: {
    DateFilter
  },
  data() {
    return {
      loading: false,
      refreshInterval: '',
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      headers: [
        // { text: this.$t('Product ID'), value: 'productid', width: '1%', align: 'center' },
        {
          text: this.$t('Admin'),
          value: 'productname',
          align: 'center',
          align: 'center'
        },
        {
          text: this.$t('ตอบกลับถายใน'),
          value: 'totalquantity',
          align: 'center',

          align: 'center'
        },
        {
          text: this.$t('จำนวนข้อความตอบกลับ'),
          value: 'closetask',
          align: 'center',
          align: 'center'
        },
        {
          text: this.$t('การตอบกลับล่าสุด'),
          value: 'lastestpreply',
          align: 'center',
          align: 'center'
        }
      ],
      desserts: [],
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  created() {
    var vm = this
    vm.getadminperformbypageid()
    vm.refreshInterval = setInterval(function() {
      vm.getadminperformbypageid()
    }, 10000)
  },
  methods: {
    onDateChanged(value) {
      clearInterval(this.refreshInterval)
      var vm = this
      vm.getadminperformbypageid()
      //only reset for today
      if (
        moment(new Date()).format('YYYY-MM-DD') == value.start &&
        moment(new Date()).format('YYYY-MM-DD') == value.end
      ) {
        vm.refreshInterval = setInterval(function() {
          vm.getadminperformbypageid()
        }, 10000)
      }
    },
    dayLeft: function(second) {
      var duration = moment.duration(parseInt(second), 'seconds')
      var time = ''
      if (duration.minutes() > 0) {
        time = duration.minutes()
        time += ' <span >' + this.$t('Minutes') + '</span>'
      } else {
        time = duration.seconds()
        time += ' <span >' + this.$t('Seconds') + '</span>'
      }
      return time
    },
    getadminperformbypageid() {
      var vm = this
      vm.loading = true
      var data = {
        dateFrom: this.selectedDate.start,
        dateTo: this.selectedDate.end,
        pageid: this.selectedBot.pageid
      }
      api.getadminperformbypageid(data, (err, response) => {
        vm.loading = false
        if (response.responsecode == 200) {
          vm.desserts = response.data
        }
      })
    }
  },
  beforeDestroy: function() {
    clearInterval(this.refreshInterval)
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/RussianRouletteDashboard.vue